import { RefObject, useEffect, useRef } from 'react';

/**
 * Simple hook to detect clicks outside the component.
 * It functionally works the same as useTogglePanel in @xemplo/user-options
 */
export const useClickOutside = (
  handleOnClickOutside?: (event: MouseEvent | TouchEvent) => void,
  additionalRefs: RefObject<HTMLElement>[] = []
) => {
  const ref = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      if (!ref.current) return;

      const isClickInsideRef = ref.current.contains(event.target as Node);
      const isClickInsideAdditional = additionalRefs.some((ref) =>
        ref.current?.contains(event.target as Node)
      );
      if (isClickInsideRef || isClickInsideAdditional) return;
      handleOnClickOutside?.(event);
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [handleOnClickOutside, additionalRefs]);
  return {
    ref,
  };
};
